import { environment } from "@environments/environment";

export const API_ENDPOINTS = {
  LOGIN: `${environment.host}/securityv2/v2/security/token/create`,
  LOGOUT: `${environment.host}/securityv2/OIDC/v2.0/revoke`,
  REFRESH: `${environment.host}/securityv2/OIDC/v2.0/token`,
  DOCUMENT: `v1/agile-credits/integration/document-manager/check-in`,
  UPLOAD_DOCUMENT: `v1/agile-credits/integration/document-manager/upload`,
  VERIFY_DOCUMENT: `v1/agile-credits/integration/document-manager/binnacle`,
  REQUEST: 'v1/agile-credits/integration/start-instance',
  TRACKING: `v1/agile-credits/tracking`,
  CATALOGS: `v1/agile-credits/catalogs`,
  CATALOGS_TYPE: {
    country: 'PAIS',
    province: 'PROVINCIA',
    district: 'DISTRITO',
    city: 'CORREGIMIENTO',
    documentType: 'TIPOS_DOCUMENTOS',
    maritalStatus: 'ESTADO_CIVIL',
    occupation: 'OCUPACION',
    sourceIncome: 'FUENTE_INGRESOS',
    sector: 'SECTOR',
    vehicleType: 'TIPO_VEHICULOS',
    useVehicleType: 'USO_VEHICULO',
    agencies: 'AGENCIAS',
    vehicleMark: 'MARCAS_VEHICULOS',
    gender: 'GENERO',
    company: 'EMPRESAS',
    executives: 'AGENTES',
  }
}
